module.exports = __webpack_public_path__ + "static/img/10.bb5483f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/services/10.png
// module id = 0q9J
// module chunks = 0